import React from "react";
import Image from "next/image";

/**
 * Step-by-step process for becoming a trainer at Spot Formations.
 */
const HowItWorksSection: React.FC = () => {
    const steps = [
        "Vous remplissez votre fiche de formateur",
        "Vous choisissez votre formule : à l'unité ou en abonnement",
        "Vous recevez des leads, organisez vos sessions, et formez en toute simplicité"
    ];

    return (
        <section className="py-[35.77px] bg-[#EFEFEF]">
            <div className="max-w-125 mx-auto px-4">
                <h2 className="font-red-hat text-[30px] sm:text-[40px] text-[#1B515E] leading-9 sm:leading-13.25 font-light text-center mb-8 sm:mb-12.75">Comment ça marche ?</h2>

                <div className="w-full">
                    <div className="flex flex-col items-center">
                        {steps.map((step, idx) => (
                            <div key={idx} className="flex flex-col items-center w-full">
                                <div className="flex items-start gap-2.5 w-full pt-0.5 px-2.5">
                                    <Image
                                        src="/assets/icons/orange-check.svg"
                                        alt="Step completed"
                                        className="mt-0.75"
                                        width={20}
                                        height={20}
                                    />
                                    <p className="font-normal text-[14px] sm:text-[16px] leading-6.5 text-[#1D1D1D] tracking-[0.2px]">{step}</p>
                                </div>
                                {idx < steps.length - 1 && (
                                    <div className="w-full pl-4 flex justify-start h-10 sm:h-11.25">
                                        <Image
                                            src="/assets/icons/downward-arrow.svg"
                                            alt="Next step"
                                            className="h-full"
                                            width={8}
                                            height={46}
                                        />
                                    </div>
                                )}

                            </div>
                        ))}

                    </div>
                </div>
            </div>
        </section>
    );
};

export default HowItWorksSection;
